import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider as ReduxProvider } from "react-redux";
import MainStore from "./store";
import { ChakraProvider } from "@chakra-ui/react";
import { LocalizationProvider } from "@material-ui/pickers";
import MomentUtils from "@material-ui/pickers/adapter/moment";
ReactDOM.render(
  <React.StrictMode>
    <ReduxProvider store={MainStore}>
      <LocalizationProvider dateAdapter={MomentUtils}>
        <ChakraProvider>
          <App />
        </ChakraProvider>
      </LocalizationProvider>
    </ReduxProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
